import { Table, TableRow, TableCell, Paragraph, WidthType, TableLayoutType } from 'docx';
import { DEFAULT_CONTENT_WIDTH, equalWidths } from './utils';

export const createOnIncelemeTable = (onIncelemeInfo, contentWidth = DEFAULT_CONTENT_WIDTH) => {
  const cols = equalWidths(contentWidth, 2);
  return new Table({
    width: { size: contentWidth, type: WidthType.DXA },
    layout: TableLayoutType.FIXED,
    columnWidths: cols,
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph("Ön İncelemede Tespit Edilen Hususlar")],
            columnSpan: 2,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph(onIncelemeInfo)],
            columnSpan: 2,
          }),
        ],
      }),
    ],
  });
};